import UserDetailsForm from 'src/components/BuyPolicy/insuranceScreens/health/UserDetailsForm'

const FamilyMembersModal = ({ onEdit }) => {
  return (
    <>
      <UserDetailsForm editForm={true} onEdit={onEdit} />
    </>
  )
}

export default FamilyMembersModal
